<script setup lang="ts">
const {
  useCorePromotions,
  promotionsUrlWpApi,
  promotionsUrlIframe,
  linkToPromotions,
} = useLinks();
</script>

<template>
  <BasePromotionsCore v-if="useCorePromotions" />
  <BasePromotionsWP v-else-if="promotionsUrlWpApi" />
  <BasePromotionsIframe v-else-if="promotionsUrlIframe" />

  <div
    v-else-if="linkToPromotions"
    :class="$style.promotionsAccess"
  >
    <a
      class="btn btn-primary"
      :href="linkToPromotions"
      target="_blank"
    >
      <IconBullhorn />
      {{ $t('access_promotions') }}
    </a>
  </div>

  <div
    v-else
    class="pb-2"
  >
    <div class="alert alert-warning">
      <span>{{ $t('no_promotions_found') }}</span>
    </div>
  </div>
</template>

<style module lang="postcss">
.promotionsAccess {
  @apply text-center flex items-center justify-center mb-5 py-20;

  a {
    @apply text-base md:text-lg py-2 md:py-3 px-4 md:px-8 rounded-full;
  }
}
</style>
